import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import donutHero from '../assets/donut-hero.jpg';
import Testimonials from '../components/Testimonials.jsx';

export default function WelcomePage() {
  const { t } = useTranslation();

  const stepImages = [
    { src: 'step1', key: 'steps.mixing' },
    { src: 'step2', key: 'steps.shaping' },
    { src: 'step3', key: 'steps.frying' },
    { src: 'step4', key: 'steps.glazing' },
    { src: 'step5', key: 'steps.done' },
  ];

  return (
    <div className="relative bg-pink-50 dark:bg-gray-900 pb-24">
      <img src={donutHero} alt={t('welcome.imageAlt')} className="w-full h-[70px] object-cover" />

      {/* Sticky order button, appears after banner */}
      <div className="sticky top-0 z-40 flex justify-end px-4 py-2 bg-pink-50/80 dark:bg-gray-900/80 backdrop-blur-md">
        <Link
          to="/order"
          className="font-heading bg-pink-600 hover:bg-pink-700 text-white font-bold py-3 px-6 rounded-full shadow-lg transition-shadow"
        >
          {t('welcome.cta')}
        </Link>
      </div>

      <div className="px-6 text-center">
        <h1 className="font-heading text-5xl md:text-6xl text-pink-700 mb-4">
          {t('welcome.title')}
        </h1>
        <p className="font-body italic font-light text-xl text-gray-700 dark:text-gray-300 mb-6 max-w-xl mx-auto tracking-wide">
          {t('welcome.subtitle')}
        </p>

        {/* Step images */}
        <div className="flex flex-wrap justify-center gap-6 max-w-6xl mx-auto mb-12">
          {stepImages.map(({ src, key }, idx) => (
            <div key={idx} className="text-center w-full sm:w-1/2 lg:w-1/3 max-w-xs">
              <img
                src={`/images/${src}.png`}
                alt={`Step ${idx + 1}`}
                className="rounded-lg shadow-lg object-cover w-full h-48 mb-3"
              />
              <p className="font-light italic text-gray-700 dark:text-gray-300 text-md md:text-lg tracking-wide">
                {t(key)}
              </p>
            </div>
          ))}
        </div>

        <Testimonials />
      </div>
    </div>
  );
}
